import { createEntity } from 'lib/resource';
import UserProfile from './schema';

const entity = createEntity(UserProfile);
const update = entity.update.bind(entity);

/**
 * The following override ensures that the profile is referenced
 * through the user id versus the profile id so when it gets
 * consolidated back into the store it will overwrite the correct
 * object and not create a duplicate.
 */
entity.update = (id, profile) => update(profile.user, profile);

/**
 * The profile cannot be deleted so here we will simply reject it.
 */
entity.delete = () => Promise.reject(new Error('Not allowed.'));

export default entity;
